<template>
    <div class="history-container">
        <template v-if="list.length && show">
            <div class="list-area">
                <div
                    v-for="(item, index) of list"
                    :key="item.id"
                    class="list-item"
                    :class="selected === index ? 'selected' : ''"
                    @click="selected = index"
                >
                    <overflow-tooltip
                        overflow-class="title"
                        overflow="x"
                        position="auto-start"
                    >
                        <span
                            slot="default"
                        >{{ item.contract_type
                        }}{{ item.query ? " | " + item.query : "" }}</span>

                        <template slot="tip">
                            <div class="popover-title">
                                {{ item.contract_type }}
                            </div>
                            {{ item.query }}
                        </template>
                    </overflow-tooltip>
                </div>
                <div class="tips">仅保留最近10条记录</div>
            </div>
            <div class="result-area">
                <div v-if="curContract" class="result-wrapper">
                    <div class="header">
                        <h3>根据您的要求生成的AI合同</h3>
                        <span
                            v-if="curContract.update_time" class="time"
                        >生成时间：{{
                            curContract.update_time | dateFormat
                        }}</span>
                        <div class="download-btn" @click="handleDownload">
                            下载word
                        </div>
                    </div>
                    <div class="prompt">
                        合同要求：
                        <span class="prompt-type">{{
                            curContract.contract_type
                        }}</span>
                        <template v-if="curContract.query">
                            +
                            <span ref="query-tooltip" class="prompt-query">{{
                                curContract.query
                            }}</span>
                        </template>
                    </div>
                    <div class="content">
                        <div class="content-paper">
                            {{ curContract.contract_content }}
                        </div>
                    </div>
                    <veui-popover
                        v-if="curContract.query"
                        target="query-tooltip"
                        position="bottom"
                    >
                        {{ curContract.query }}
                    </veui-popover>
                </div>
            </div>
        </template>
        <!-- 空状态 -->
        <div v-else class="empty">
            <i class="empty-pic"></i>
            <span>还没有生成记录，赶快点击上方按钮开始生成吧~</span>
        </div>
    </div>
</template>
<script>
/**
 * @file 历史记录页面
 */
import {Popover} from 'veui';
import {
    percentFormat,
    dateFormat,
    getContractDocLink,
    getContractList
} from '../util';
import {downloadFile} from '@/utils/download';
import OverflowTooltip from '../../../components/overflowTooltip.vue';

export default {
    components: {
        'veui-popover': Popover,
        'overflow-tooltip': OverflowTooltip
    },
    filters: {
        percentFormat,
        dateFormat
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // 合同
            list: [],
            selected: 0,
            isDownloading: false
        };
    },
    computed: {
        curContract() {
            return this.list[this.selected];
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            getContractList('1').then(list => {
                this.list = list;
            }).catch(() => {
                this.list = [];
            });
        },
        handleDownload() {
            if (this.isDownloading || !this.curContract) {
                return;
            }
            this.isDownloading = true;

            this.$wywLog.send({
                serverId: 17047,
                action: 'click',
                area: 'btn-xzword'
            });
            const {id, bos_link, contract_type, update_time}
                = this.curContract;
            getContractDocLink(this.curContract)
                .then(bosLink => {
                    downloadFile(
                        bosLink,
                        `${contract_type}-${dateFormat(update_time)}`
                    );
                    // 将新获取到的链接写回列表
                    if (!bos_link) {
                        const contractIndex = this.list.findIndex(
                            ({id: itemId}) => itemId === id
                        );
                        this.$set(
                            this.list[contractIndex],
                            'bos_link',
                            bosLink
                        );
                    }
                })
                .catch(msg => {
                    this.$Message.error(msg || '文件获取失败，请稍后再试');
                })
                .finally(() => {
                    this.isDownloading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.history-container {
    display: flex;
    align-items: stretch;
    position: relative;
    min-height: 733px;

    .list-area {
        position: relative;
        flex-shrink: 0;
        width: 274px;
        min-height: 733px;
        padding: 17px 30px 30px;
        border-right: 1px solid #e9ecf3;

        .list-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 50px;

            .title {
                flex: 1 1 0;
                text-overflow: ellipsis;
                overflow: hidden;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #333;
                white-space: nowrap;
            }

            &.selected .title {
                color: #05f;
            }

            &::before {
                flex: 0 0 auto;
                content: "";
                width: 24px;
                height: 24px;
                background:
                    url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/ai-contract/icon-doc.png)
                    no-repeat center / cover;
                margin-right: 5px;
            }
        }

        .tips {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
        }
    }

    .result-area {
        flex: 1 1 0;
        position: relative;

        .result-wrapper {
            height: 100%;
            position: relative;

            .header {
                display: flex;
                align-items: center;
                height: 50px;
                padding: 0 20px 0 22px;

                h3 {
                    font-family: PingFangSC-Medium;
                    font-size: 14px;
                    color: #333;
                }

                .time {
                    margin-left: 17px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #9d9d9d;
                }

                .download-btn {
                    margin-left: auto;
                    cursor: pointer;
                    height: 32px;
                    padding: 0 10px;
                    display: flex;
                    align-items: center;
                    border: 1px solid #0759ff;
                    border-radius: 4px;
                    font-family: PingFangSC-Medium;
                    font-size: 12px;
                    color: #0759ff;

                    &:hover {
                        background-color: rgba(56, 85, 213, .08);
                    }

                    &::before {
                        content: "";
                        width: 16px;
                        height: 16px;
                        background:
                            url(https://lvlin-base.cdn.bcebos.com/fe-saas/page/ai-contract/icon-word.png)
                            no-repeat center / cover;
                        margin-right: 2px;
                    }
                }
            }

            .prompt {
                position: relative;
                height: 52px;
                padding: 0 20px 24px;
                display: flex;
                align-items: center;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #333;

                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 24px;
                    box-shadow: 0 3px 5px 0 rgba(215, 220, 233, .43);
                    z-index: 1;
                }

                .prompt-type,
                .prompt-query {
                    background: rgba(56, 85, 213, .08);
                    border-radius: 4px;
                    height: 25px;
                    padding: 0 14px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333;
                    line-height: 25px;
                }

                .prompt-type {
                    margin-right: 8px;
                }

                .prompt-query {
                    margin-left: 8px;
                    max-width: 27em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            .content {
                position: absolute;
                top: 102px;
                left: 0;
                width: 100%;
                height: calc(100% - 102px);
                overflow-y: auto;
                white-space: pre-wrap;
                padding: 0 95px;
                background: #e9ebf4;

                .content-paper {
                    background: #fff;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #000;
                    padding: 26px 68px;
                    min-height: 100%;
                }
            }
        }
    }

    .empty {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #666;
        text-align: center;
        line-height: 14px;

        .empty-pic {
            margin-top: 206px;
            margin-bottom: 18px;
            width: 180px;
            height: 144px;
            background:
                url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/ai-contract/empty.png")
                no-repeat center / cover;
        }
    }
}

.popover-title {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333;
}
</style>
